<mat-form-field fxFlex="100">
  <input matInput type="text" (change)="valueChanged($event)"
         [(ngModel)]="inputValue" [disabled]="disabled"
         [textMask]="{mask: formatter.integer.mask, pipe: formatter.integer.pipe, guide: true, placeholderChar: formatter.placeholderChar}"/>
  <mat-placeholder i18n>{{placeholder}}</mat-placeholder>
  <span *ngIf="suffix" matSuffix i18n>{{suffix}}</span>
</mat-form-field>
